export default {"src":"https://web.cdn.greenlight.com/2.196.3/_next/static/media/gl-logo.056fd461.svg","height":31,"width":37};